import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SeriesTable from './SeriesTable';
import SeasonTable from './SeasonTable';
import EpisodeTable from './EpisodeTable';
import SeriesWizard from './SeriesWizard';
import ImportSeriesModal from './ImportSeriesModal';
import { fetchSeries } from '../redux/slices/seriesSlice';
import { Upload, Plus } from 'lucide-react';

const SeriesManagement = () => {
  const [activeTab, setActiveTab] = useState('series');
  const [showWizard, setShowWizard] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSeries());
  }, [dispatch]);

  const handleAddNewClick = () => {
    setShowWizard(true);
  };

  const handleWizardClose = () => {
    setShowWizard(false);
  };
  
  const handleOpenImportModal = () => {
    console.log("Abriendo modal de importación CSV jerárquica para series");
    setIsImportModalOpen(true);
  };

  const handleCloseImportModal = (redirectData) => {
    console.log("Cerrando modal de importación CSV jerárquica para series", redirectData);
    setIsImportModalOpen(false);
    
    // Si hay datos de redirección, establecer la pestaña de episodios como activa
    if (redirectData && redirectData.redirectToEpisodes) {
      setActiveTab('episodes');
    }
  };

  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Gestión de Series</h1>
        <div className="flex space-x-3">
          <button
            onClick={handleOpenImportModal}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-lg transition-colors duration-200"
          >
            <Upload className="h-5 w-5" />
            Importar CSV
          </button>
          <button 
            onClick={handleAddNewClick}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition-colors duration-200"
          >
            <Plus className="h-5 w-5" />
            Añadir Nueva
          </button>
        </div>
      </div>

      <div className="mb-6">
        <div className="border-b border-gray-200">
          <nav className="flex -mb-px">
            <button
              className={`mr-8 py-4 px-1 ${
                activeTab === 'series'
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              onClick={() => setActiveTab('series')}
            >
              Series
            </button>
            <button
              className={`mr-8 py-4 px-1 ${
                activeTab === 'seasons'
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              onClick={() => setActiveTab('seasons')}
            >
              Temporadas
            </button>
            <button
              className={`mr-8 py-4 px-1 ${
                activeTab === 'episodes'
                  ? 'border-b-2 border-blue-500 text-blue-600'
                  : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
              onClick={() => setActiveTab('episodes')}
            >
              Episodios
            </button>
          </nav>
        </div>
      </div>

      <div className="tab-content">
        {activeTab === 'series' && <SeriesTable />}
        {activeTab === 'seasons' && <SeasonTable seriesMode={true} />}
        {activeTab === 'episodes' && <EpisodeTable seriesMode={true} />}
      </div>

      {showWizard && <SeriesWizard isOpen={showWizard} onClose={handleWizardClose} />}
      {isImportModalOpen && <ImportSeriesModal isOpen={isImportModalOpen} onClose={handleCloseImportModal} />}
    </div>
  );
};

export default SeriesManagement;
